import { render, staticRenderFns } from "./print_card.vue?vue&type=template&id=3d163874&lang=pug&"
import script from "./print_card.vue?vue&type=script&setup=true&lang=js&"
export * from "./print_card.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports